module.exports = __webpack_public_path__ + "img/博学@2x.cff8321c.png";